import { cn } from '~/common/utils/styleUtil';
import type { SimpleFooterLink } from '~/config/types/webshopConfiguration';
import { getLinkRel } from '~/common/utils/urlUtil';
import { FooterIcon } from '~/shell/components/footer/FooterIcon';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

export function FooterSocialLinks({ links }: Readonly<{ links: SimpleFooterLink[] }>) {
  return (
    <ul className={'flex gap-8 mt-8 items-center'}>
      {links.map(link => {
        return (
          <li key={link.titleKey} className={cn('py-2 hover:text-primary')}>
            <TrackNavigationClick label={link.titleKey}>
              <a href={link.url} target={'_blank'} rel={getLinkRel(link.url)} data-testid={`footer-${link.titleKey}`}>
                {link.icon && <FooterIcon icon={link.icon} />}
              </a>
            </TrackNavigationClick>
          </li>
        );
      })}
    </ul>
  );
}
